const Wrapper: React.FC<{ children: React.ReactNode }> = props => {
  return (
    <div className="container">
      <div className="row">
        <div className="col">{props.children}</div>
      </div>
    </div>
  );
};

export default Wrapper;
